export requestFullScreen = (el) -> (el.requestFullScreen ? el.webkitRequestFullScreen ? el.mozRequestFullScreen)?.call el
export cancelFullScreen = (el) -> (el.exitFullScreen ? el.webkitCancelFullScreen ? el.mozCancelFullScreen)?.call el

window.toggleFullScreen = ->
	if document.fullscreenElement or document.webkitFullscreenElement or document.mozFullscreenElement
		cancelFullScreen document
		false
	else
		requestFullScreen document.documentElement
		true

export createImage = (src) -> Object.assign new Image, {src}

export httpGet = (name, type, onload) ->
	request = new XMLHttpRequest
	request.open 'GET', '/' + name
	request.responseType = type
	request.onreadystatechange = -> if @readyState == @DONE
		onload @status == 200 and @response ? undefined
	request.send()

export fitString = (c, s, width) ->
	ew = c.measureText('…').width
	w = c.measureText(s).width
	return [s, w] if w < width
	len = s.length
	while w >= width && len-- > 0
		s = s.substring 0, len
		w = c.measureText(s).width + ew
	return [s + '…', w]

export htmlColor = (c) -> "##{('000000' + c.toString(16)).slice(-8, -2)}"

export throttle = (delay, fn) ->
	isThrottled = false
	args = self = undefined
	wrapper = ->
		if isThrottled
			args = arguments
			self = this
			return
		fn.apply this, arguments
		isThrottled = true
		setTimeout ->
			isThrottled = false
			if args?
				wrapper.apply self, args
				args = self = undefined
		, delay

KeyboardEvent::getCode = -> @code or do =>
	KeyboardEvent::codes =
		9:'Tab', 13:'Enter', 16:'ShiftLeft', 17:'ControlLeft', 18:'AltLeft', 20:'CapsLock', 27:'Escape', 32:'Space'
		48:'Digit0', 49:'Digit1', 50:'Digit2', 51:'Digit3', 52:'Digit4', 53:'Digit5', 54:'Digit6', 55:'Digit7', 56:'Digit8', 57:'Digit9'
		81:'KeyQ', 87:'KeyW', 69:'KeyE', 82:'KeyR', 84:'KeyT', 65:'KeyA', 83:'KeyS', 68:'KeyD', 70:'KeyF', 71:'KeyG'
		219:'BracketLeft', 221:'BracketRight', 220:'Backslash'
	KeyboardEvent::getCode = -> @codes[@which or @keyCode]
	@getCode()



// WEBPACK FOOTER //
// ./client/tools.coffee